<template>
  <div class="booking">
    <div class="booking-calendar">
      <div class="booking-calendar-days">
        <div class="calendar-day" v-for="(d, index) in getWeeksFromStartDate(startDate)" :key="`day-${index}`">
          <div class="day-title p-2">
            <h6 class="text-muted mb-0">{{ getDay(d) }}</h6>
            <h6 class="mb-0">{{ formatDay(d) }}</h6>
          </div>

          <div @click="saveHour(h)" class="calendar-hour d-flex flex-column" :class="{ 'hour-saved': isSaved(h), 'hour-booked': isBooked(h) }" v-for="(h, index) in getArrayOfMinutes(d)" :key="index">
            <span v-if="isAdmin" class="user-hour"><i class="ri-delete-bin-line"></i></span>
            <span v-if="isSaved(h)" class="remove-hour"><i class="ri-delete-bin-line"></i></span>
            <div>{{ formatMinute(h) }}</div>
            <div style="font-size: 10px;">{{ getEmailByDate(h) }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="booking-actions">
      <div class="action" :class="{ 'is-disable': canPrevious() }" @click="previous">
        <i class="ri-arrow-left-circle-line"></i>
      </div>
      <div class="action" @click="goToday">
        Date d'aujourd'hui
      </div>
      <div class="action" @click="next">
        <i class="ri-arrow-right-circle-line"></i>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

moment.locale('fr')

export default {
  props: {
    isAdmin: {
      type: Boolean,
      default: false
    },
    roomId: Number,
    userEmail: String
  },

  data() {
    return {
      startDate: moment(),
      bookeds: [],
      saved: []
    }
  },

  watch: {
    startDate() {
      this.fetchData()
    }
  },

  methods: {
    goToday() {
      this.startDate = moment().utc()
    },

    canPrevious() {
      return !this.startDate.isAfter(moment())
    },

    previous() {
      if (this.startDate.isAfter(moment())) {
        this.startDate = moment(this.startDate).subtract(6, 'day')
      }
    },

    next() {
      this.startDate = moment(this.startDate).add(6, 'day')
    },

    getDay(date) {
      return moment(date).format('dddd')
    },

    parseDate(date) {
      return moment(date).format('M D YYYY HH:mm')
    },

    getEmailByDate(date) {
      const d = this.bookeds.find((d) => this.parseDate(d.booked_date) === this.parseDate(date))
      const a = this.saved.find((d) => this.parseDate(d.booked_date) === this.parseDate(date))

      if (a && a.user) {
        return a.user.email
      }

      if (d && d.user) {
        return d.user.email
      }

      return 'Disponible'
    },

    isBooked(date) {
      return !!this.bookeds.find((d) => this.parseDate(d.booked_date) === this.parseDate(date))
    },

    isSaved(date) {
      return !!this.saved.find((d) => this.parseDate(d.booked_date) === this.parseDate(date))
    },

    saveHour(date) {
      if (!this.isBooked(date)) {
        axios.post(`/webapi/rooms/${this.roomId}/book`, {
          date: moment(date).second(0).toString()
        })
        .then((response) => {
          if (this.isSaved(date)) {
            const bookIndex = this.saved.findIndex(d => this.parseDate(d.booked_date) === this.parseDate(date))
            this.saved.splice(bookIndex, 1)
          } else {
            this.saved.push({ booked_date: moment(date).second(0).toDate(), user: { email: this.userEmail }})
          }
        })
        .catch((error) => {
          console.log(error.response)
        })
      }
    },

    formatDay(date) {
      return moment(date).format('DD MMMM YYYY')
    },

    formatMinute(date) {
      return moment(date).format('HH:mm')
    },

    getWeeksFromStartDate(date) {
      const result = []

      const start = moment(date)

      result.push(moment(start))

      const end = moment(date).add(6, 'day')

      let iterate = true
      while(iterate) {
        const newDate = start.add(1, 'day')

        if (newDate.isAfter(end)) {
          iterate = false

          break
        }

        result.push(moment(newDate))
      }

      return result
    },

    getArrayOfMinutes(date) {
      const result = []

      const start = moment(date).hour(9).minute(0)
      const stopDate = moment(date).hour(17).minute(30)

      result.push(moment(start))

      let iterate = true

      while (iterate) {
        const newDate = start.add(30, 'minute')

        if (newDate.isAfter(stopDate)) {
          iterate = false

          break
        }

        result.push(moment(newDate))
      }

      return result
    },

    fetchData () {
      axios.get(`/webapi/rooms/${this.roomId}/booked`, {
          params: {
            startDate: this.startDate.toISOString()
          }
      }).then((response) => {
        if (response.data.bookeds.length) {
          for (let i = 0; i < response.data.bookeds.length; i++) {
            this.saved.push(response.data.bookeds[i])
          }
        }

        if (response.data.userBookeds.length) {
          for (let i = 0; i < response.data.userBookeds.length; i++) {
            this.saved.push(response.data.userBookeds[i])
          }
        }
      })
    }
  },

  mounted() {
    this.fetchData()
  }
};
</script>
